import {Component, computed, input} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {SectionStatus} from '../step-1-1-company-information.types';

const STATUS_LABEL_KEY: Record<SectionStatus, string> = {
  empty: 'project.steps.companyInfo.statusNotStarted',
  'in-progress': 'project.steps.companyInfo.statusInProgress',
  complete: 'project.steps.companyInfo.statusComplete',
};

const STATUS_COLOR_CLASS: Record<SectionStatus, string> = {
  empty: 'text-gray',
  'in-progress': 'text-blue',
  complete: 'text-green',
};

@Component({
  selector: 'app-section-status-chip',
  imports: [TranslocoPipe],
  templateUrl: './section-status-chip.component.html',
  styleUrl: './section-status-chip.component.scss',
})
export class SectionStatusChipComponent {
  readonly status = input.required<SectionStatus>();
  readonly testId = input('section-status-chip');

  protected readonly labelKey = computed(() => STATUS_LABEL_KEY[this.status()]);
  protected readonly colorClass = computed(() => STATUS_COLOR_CLASS[this.status()]);
}
